/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT || 'http://localhost:4502/graphql/execute.json/ewsr';
const GRAPHQL_AUTH = process.env.REACT_APP_GRAPHQL_AUTH;
const ROOT_PATH = process.env.REACT_APP_CONTENT_ROOT_PATH || '/content/dam/ews/ewsr/connect/2026/cx-days';
const SPEAKER_ROOT_PATH = process.env.REACT_APP_SPEAKER_ROOT_PATH || ROOT_PATH;

const runPersistedQuery = async (queryName, variables = {}) => {
  const headers = {};
  if (GRAPHQL_AUTH) {
    headers['Authorization'] = `Basic ${GRAPHQL_AUTH}`;
  }
  
  const allVars = { rootPath: ROOT_PATH, ...variables };
  let variablesString = encodeURIComponent(Object.keys(allVars).map(key => {
    const val = (typeof allVars[key] === 'string') ? allVars[key] : JSON.stringify(allVars[key]);
    return `;${key}=${val}`;
  }).join(''));
  
  if (variablesString) {
    variablesString += ';';
  }
  
  const url = `${GRAPHQL_ENDPOINT}/${queryName}${variablesString}?t=${Math.floor(Date.now() / 300000)}`;
  
  const res = await fetch(url, { headers, cache: 'no-store' });
  
  if (!res.ok) throw new Error(`GraphQL error: ${res.status}`);
  return await res.json();
};

export const fetchSpeakers = async () => {
  const data = await runPersistedQuery('getConnectSpeakers', { rootPath: SPEAKER_ROOT_PATH });
  return data;
};

export const fetchSchedule = async () => {
  try {
    return await runPersistedQuery('getConnectSchedule');
  } catch (err) {
    console.warn('GraphQL schedule failed:', err);
    return { data: { connectScheduleList: { items: [] } } };
  }
};

export const fetchSessions = async (speakerPath = null) => {
  try {
    const variables = speakerPath ? { speakerPath } : {};
    return await runPersistedQuery('getConnectSession', variables);
  } catch (err) {
    console.warn('GraphQL sessions failed:', err);
    return { data: { connectSessionList: { items: [] } } };
  }
};

export const fetchGondolas = async (schedulePath = null) => {
  try {
    const variables = schedulePath ? { schedulePath } : {};
    return await runPersistedQuery('getConnectGondolas', variables);
  } catch (err) {
    console.warn('GraphQL gondolas failed:', err);
    return { data: { connectGondolaList: { items: [] } } };
  }
};

export const fetchConsent = async () => {
  try {
    return await runPersistedQuery('getConnectConsent')
  } catch (err) {
    console.warn('GraphQL consent failed:', err)
    return { data: { connectConsentList: { items: [] } } }
  }
}

export const fetchGallerySections = async () => {
  try {
    return await runPersistedQuery('getConnectGallerySections')
  } catch (err) {
    console.warn('GraphQL gallery sections failed:', err)
    return { data: { connectGallerySectionList: { items: [] } } }
  }
}

export const fetchGallerySectionImages = async (sectionPath) => {
  try {
    return await runPersistedQuery('getGallerySectionImages', { path: sectionPath })
  } catch (err) {
    console.warn('GraphQL gallery images failed:', err)
    return { data: { connectGallerySectionByPath: { item: { images: [] } } } }
  }
}
